// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"pagecard_cardBody__19rfx"};